module.exports = __webpack_public_path__ + "assets/41c2ae6464cb9ab5d424c7677271a530.svg";